import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-public-layout',
    templateUrl: './public-layout.component.html',
    styleUrls: ['./public-layout.component.scss'],
    standalone: false
})
export class PublicLayoutComponent implements OnInit {


  constructor() { }

  ngOnInit() {}

}
